export default "__VITE_ASSET__9e5fe82d__"